module.exports = __webpack_public_path__ + "static/penguin-0f6822cee300dab940107455ead4fa0f.svg";